var _0x1a734c = _0x87ad;
(function (_0x47e087, _0x1bb815) {
  var _0x409419 = _0x87ad,
    _0x4435c2 = _0x47e087();
  while (!![]) {
    try {
      var _0x341da2 =
        (parseInt(_0x409419(0x192)) / 0x1) *
          (-parseInt(_0x409419(0x180)) / 0x2) +
        parseInt(_0x409419(0x1d4)) / 0x3 +
        (-parseInt(_0x409419(0x17c)) / 0x4) *
          (-parseInt(_0x409419(0x193)) / 0x5) +
        -parseInt(_0x409419(0x1a4)) / 0x6 +
        -parseInt(_0x409419(0x1ab)) / 0x7 +
        -parseInt(_0x409419(0x1bb)) / 0x8 +
        (parseInt(_0x409419(0x1aa)) / 0x9) * (parseInt(_0x409419(0x1db)) / 0xa);
      if (_0x341da2 === _0x1bb815) break;
      else _0x4435c2["push"](_0x4435c2["shift"]());
    } catch (_0x3d34e1) {
      _0x4435c2["push"](_0x4435c2["shift"]());
    }
  }
})(_0x89ee, 0x9c185);
var _0x4389 = [
    _0x1a734c(0x1b8),
    _0x1a734c(0x186),
    _0x1a734c(0x1c3),
    _0x1a734c(0x1c1),
    _0x1a734c(0x190),
    _0x1a734c(0x1a3),
    "style[type=lazyload2]",
    "13yTGRoL",
    _0x1a734c(0x1bf),
    _0x1a734c(0x198),
    _0x1a734c(0x18b),
    _0x1a734c(0x1c8),
    _0x1a734c(0x1cc),
    "touchstart",
    _0x1a734c(0x1b2),
    _0x1a734c(0x1d9),
    _0x1a734c(0x1a2),
    _0x1a734c(0x19d),
    _0x1a734c(0x1a9),
    _0x1a734c(0x1b5),
    _0x1a734c(0x1a8),
    _0x1a734c(0x1da),
    _0x1a734c(0x1ae),
    _0x1a734c(0x181),
    "nodeName",
    _0x1a734c(0x1b3),
    _0x1a734c(0x17f),
    _0x1a734c(0x1c7),
    "37AgNFNI",
    _0x1a734c(0x1c0),
    _0x1a734c(0x18c),
    _0x1a734c(0x1a5),
    _0x1a734c(0x19b),
    _0x1a734c(0x1a0),
    "rel",
    "iframe",
    _0x1a734c(0x1b1),
    "classList",
    _0x1a734c(0x188),
    _0x1a734c(0x17d),
    _0x1a734c(0x1c6),
    _0x1a734c(0x1d7),
    _0x1a734c(0x1cf),
    "nextSibling",
    _0x1a734c(0x197),
    "link",
    "6869ugfVJo",
    _0x1a734c(0x17e),
    _0x1a734c(0x1d3),
    "mobstyle",
    _0x1a734c(0x19c),
    _0x1a734c(0x1d0),
    _0x1a734c(0x1d8),
    "getBoundingClientRect",
    _0x1a734c(0x17a),
    _0x1a734c(0x1bd),
    _0x1a734c(0x1c9),
    "7bVfFrd",
    _0x1a734c(0x191),
    "196422OBbQuL",
    _0x1a734c(0x18f),
    "1itFOYw",
    _0x1a734c(0x199),
    _0x1a734c(0x1c2),
    _0x1a734c(0x19f),
    _0x1a734c(0x19a),
    _0x1a734c(0x1cd),
    "setAttribute",
    _0x1a734c(0x1b6),
    "Yes-optimization",
    _0x1a734c(0x1a1),
    _0x1a734c(0x184),
    "data-src",
    "mobsrc",
    _0x1a734c(0x182),
    _0x1a734c(0x1a6),
    _0x1a734c(0x18e),
    _0x1a734c(0x195),
    _0x1a734c(0x1b4),
    _0x1a734c(0x1d5),
  ],
  _0x51e9a8 = _0x1bbc;
function _0x87ad(_0x2e1007, _0x2baf26) {
  var _0x89eee5 = _0x89ee();
  return (
    (_0x87ad = function (_0x87ad56, _0x18b16d) {
      _0x87ad56 = _0x87ad56 - 0x17a;
      var _0x5f5346 = _0x89eee5[_0x87ad56];
      return _0x5f5346;
    }),
    _0x87ad(_0x2e1007, _0x2baf26)
  );
}
!(function (_0x44e105, _0x4103d8) {
  var _0x37690b = _0x1a734c;
  for (var _0x2e73b8 = _0x1bbc; ; )
    try {
      if (
        0x49748 ===
        -parseInt(_0x2e73b8(0x1b1)) +
          parseInt(_0x2e73b8(0x19a)) * parseInt(_0x2e73b8(0x1ac)) -
          parseInt(_0x2e73b8(0x1b9)) +
          parseInt(_0x2e73b8(0x1b7)) * -parseInt(_0x2e73b8(0x195)) +
          parseInt(_0x2e73b8(0x1bb)) * parseInt(_0x2e73b8(0x19e)) -
          parseInt(_0x2e73b8(0x192)) +
          parseInt(_0x2e73b8(0x185)) * parseInt(_0x2e73b8(0x19d))
      )
        break;
      _0x44e105[_0x37690b(0x1b0)](_0x44e105["shift"]());
    } catch (_0x33f2da) {
      _0x44e105["push"](_0x44e105[_0x37690b(0x189)]());
    }
})(_0x4389);
var src,
  srcset,
  wnw_windowWidth,
  wnw_windowHeight,
  critical2,
  lazyBackground,
  lazyIframe,
  lazybg,
  xmlhttp,
  s,
  i,
  flag = 0x1,
  lazy_load_by_px = 0xc8,
  external_single_loaded = 0x1;
function wnw_init() {
  var _0x5b1c69 = _0x1a734c;
  lazyLoadImg(),
    lazyLoadBackground(),
    lazyLoadStyle(),
    lazyLoadCss(),
    lazyLoadIframe(),
    flag &&
      ((flag = 0x0),
      document[_0x5b1c69(0x1c4)][_0x5b1c69(0x196)][_0x5b1c69(0x185)](
        _0x5b1c69(0x1d6)
      ),
      load_all_js());
}
function insertAfter(_0x53529e, _0x1ec59d) {
  var _0x5ae87d = _0x1a734c,
    _0x41069d = _0x1bbc;
  _0x1ec59d[_0x41069d(0x19b)][_0x5ae87d(0x1a3)](
    _0x53529e,
    _0x1ec59d[_0x41069d(0x1a9)]
  );
}
function lazyLoadImg() {
  var _0x13a005 = _0x1a734c,
    _0x494905 = document["querySelectorAll"](_0x13a005(0x1c1));
  for (i = 0x0; i < _0x494905["length"]; i++)
    (src =
      wnw_windowWidth < 0x258
        ? void 0x0 === _0x494905[i][_0x13a005(0x186)][_0x13a005(0x1ad)]
          ? _0x494905[i][_0x13a005(0x186)]["src"]
          : _0x494905[i][_0x13a005(0x186)]["mobsrc"]
        : void 0x0 === _0x494905[i]["dataset"][_0x13a005(0x1c6)]
        ? _0x494905[i]["src"]
        : _0x494905[i][_0x13a005(0x186)]["src"]),
      (srcset = _0x494905[i]["getAttribute"](_0x13a005(0x184))
        ? _0x494905[i][_0x13a005(0x1a1)](_0x13a005(0x184))
        : ""),
      null != src && "" != src && (_0x494905[i][_0x13a005(0x1c6)] = src),
      null != srcset &&
        "" != srcset &&
        (_0x494905[i][_0x13a005(0x1a9)] = srcset),
      _0x494905[i][_0x13a005(0x196)][_0x13a005(0x1bf)](_0x13a005(0x1ae));
}
function lazyLoadImg2() {
  var _0x4cc691 = _0x1a734c,
    _0x1bd52a = document[_0x4cc691(0x1c2)](_0x4cc691(0x1ba));
  for (i = 0x0; i < _0x1bd52a[_0x4cc691(0x1b3)]; i++) {
    var _0x52a836 = _0x1bd52a[i][_0x4cc691(0x1c5)]();
    0x0 != _0x52a836[_0x4cc691(0x19a)] &&
      _0x52a836["top"] - wnw_windowHeight < 0x0 &&
      ((src =
        wnw_windowWidth < 0x258
          ? void 0x0 === _0x1bd52a[i][_0x4cc691(0x186)][_0x4cc691(0x1ad)]
            ? _0x1bd52a[i][_0x4cc691(0x186)][_0x4cc691(0x1c6)]
            : _0x1bd52a[i]["dataset"][_0x4cc691(0x1ad)]
          : void 0x0 === _0x1bd52a[i][_0x4cc691(0x186)][_0x4cc691(0x1c6)]
          ? _0x1bd52a[i][_0x4cc691(0x1c6)]
          : _0x1bd52a[i]["dataset"][_0x4cc691(0x1c6)]),
      (srcset = _0x1bd52a[i][_0x4cc691(0x1a1)]("data-srcset")
        ? _0x1bd52a[i][_0x4cc691(0x1a1)]("data-srcset")
        : ""),
      null != src && "" != src && (_0x1bd52a[i][_0x4cc691(0x1c6)] = src),
      null != srcset &&
        "" != srcset &&
        (_0x1bd52a[i][_0x4cc691(0x1a9)] = srcset),
      _0x1bd52a[i][_0x4cc691(0x196)][_0x4cc691(0x1bf)]("lazy3"));
  }
}
function lazyLoadBackground2() {
  var _0x8fd5f3 = _0x1a734c;
  (lazyBackground = document[_0x8fd5f3(0x1c2)](_0x8fd5f3(0x1ca)))[
    _0x8fd5f3(0x1cf)
  ](function (_0x8c49aa) {
    var _0x3a83f7 = _0x8fd5f3,
      _0x37fc4f = _0x8c49aa[_0x3a83f7(0x1c5)]();
    0x0 != _0x37fc4f["top"] &&
      _0x37fc4f[_0x3a83f7(0x19a)] - wnw_windowHeight < 0x0 &&
      (null !=
        (lazybg =
          wnw_windowWidth < 0x258
            ? void 0x0 === _0x8c49aa[_0x3a83f7(0x186)][_0x3a83f7(0x1d1)]
              ? _0x8c49aa["dataset"]["style"]
              : _0x8c49aa[_0x3a83f7(0x186)][_0x3a83f7(0x1d1)]
            : void 0x0 === _0x8c49aa["dataset"][_0x3a83f7(0x1b6)]
            ? _0x8c49aa[_0x3a83f7(0x1b6)]
            : _0x8c49aa[_0x3a83f7(0x186)]["style"]) &&
        "" != lazybg &&
        (_0x8c49aa["style"] = lazybg),
      _0x8c49aa[_0x3a83f7(0x196)][_0x3a83f7(0x1bf)](_0x3a83f7(0x1bc)));
  });
}
function lazyLoadBackground() {
  var _0x171c6a = _0x1a734c;
  (lazyBackground = document[_0x171c6a(0x1c2)](_0x171c6a(0x17f)))[
    _0x171c6a(0x1cf)
  ](function (_0x479fcf) {
    var _0x2c466a = _0x171c6a;
    null !=
      (lazybg =
        wnw_windowWidth < 0x258
          ? void 0x0 === _0x479fcf[_0x2c466a(0x186)]["mobstyle"]
            ? _0x479fcf[_0x2c466a(0x186)][_0x2c466a(0x1b6)]
            : _0x479fcf[_0x2c466a(0x186)][_0x2c466a(0x1d1)]
          : void 0x0 === _0x479fcf["dataset"]["style"]
          ? _0x479fcf[_0x2c466a(0x1b6)]
          : _0x479fcf[_0x2c466a(0x186)][_0x2c466a(0x1b6)]) &&
      "" != lazybg &&
      (_0x479fcf[_0x2c466a(0x1b6)] = lazybg),
      _0x479fcf["classList"][_0x2c466a(0x1bf)](_0x2c466a(0x1a2));
  });
}
function lazyLoadCss() {
  var _0x19c10e = _0x1a734c,
    _0x2243dc = document[_0x19c10e(0x1c2)]("link[data-href]");
  for (i = 0x0; i < _0x2243dc["length"]; i++) {
    var _0x59c6e6 = document[_0x19c10e(0x1a0)](_0x19c10e(0x1af));
    (_0x59c6e6["href"] = _0x2243dc[i]["getAttribute"](_0x19c10e(0x1d5))),
      (_0x59c6e6[_0x19c10e(0x1a7)] = _0x19c10e(0x1a6)),
      _0x2243dc[i][_0x19c10e(0x1c0)][_0x19c10e(0x1a3)](_0x59c6e6, _0x2243dc[i]),
      delete _0x2243dc[i]["dataset"][_0x19c10e(0x198)],
      _0x2243dc[i][_0x19c10e(0x1c0)][_0x19c10e(0x19f)](_0x2243dc[i]);
  }
}
function lazyLoadStyle() {
  var _0x1760bf = _0x1a734c,
    _0x4035b5 = document[_0x1760bf(0x1c2)]("style[type=lazyload2]");
  for (i = 0x0; i < _0x4035b5[_0x1760bf(0x1b3)]; i++) {
    var _0x2eeba5 = document[_0x1760bf(0x1a0)](_0x1760bf(0x1b6));
    (_0x2eeba5["innerHTML"] = _0x4035b5[i][_0x1760bf(0x18b)]),
      _0x4035b5[i]["parentNode"][_0x1760bf(0x1a3)](_0x2eeba5, _0x4035b5[i]),
      _0x4035b5[i][_0x1760bf(0x1c0)][_0x1760bf(0x19f)](_0x4035b5[i]);
  }
}
function lazyLoadIframe() {
  var _0x400566 = _0x1a734c;
  (lazyIframe = document["querySelectorAll"](_0x400566(0x1d2)))[
    _0x400566(0x1cf)
  ](function (_0xc9ebce) {
    var _0x54c731 = _0x400566;
    null != _0xc9ebce[_0x54c731(0x186)][_0x54c731(0x1c6)] &&
      "" != _0xc9ebce["dataset"]["src"] &&
      ((_0xc9ebce["src"] = _0xc9ebce[_0x54c731(0x186)]["src"]),
      delete _0xc9ebce["dataset"][_0x54c731(0x1c6)]);
  });
}
function _0x1bbc(_0x138faa, _0xd7a73b) {
  return (_0x1bbc = function (_0x41d49a, _0x5f504a) {
    return _0x4389[(_0x41d49a -= 0x179)];
  })(_0x138faa, _0xd7a73b);
}
function _0x89ee() {
  var _0x2e6a24 = [
    "GET",
    "name",
    "Linux\x20x86_64",
    "readyState",
    "4540650pGghBa",
    "onload",
    "checkout",
    "12aaPQDw",
    "attributes",
    "addEventListener",
    ".lazybg",
    "3898SIYMXi",
    "49817bPsRiY",
    "createEvent",
    ".analytics",
    "data-srcset",
    "add",
    "dataset",
    "responseText",
    "status",
    "shift",
    "setAttribute",
    "innerHTML",
    "document",
    ".critical2",
    "mousemove",
    "send",
    "onreadystatechange",
    "location",
    "641fuQIqR",
    "1047445SdUmmz",
    "nodeName",
    "script",
    "classList",
    "link[data-href]",
    "href",
    "log",
    "top",
    "10769ZQZjKp",
    "DOMContentLoaded2",
    "dispatchEvent",
    "height",
    "removeChild",
    "createElement",
    "getAttribute",
    "lazybg",
    "insertBefore",
    "7561020emwGfy",
    "70373nSkYrg",
    "stylesheet",
    "rel",
    "86643GCiRFH",
    "srcset",
    "81aAQAhV",
    "5321211CcAmam",
    "Yes-optimization",
    "mobsrc",
    "lazy2",
    "link",
    "push",
    "value",
    "wnw_load",
    "length",
    "width",
    "cart",
    "style",
    "data-src",
    "type",
    "appendChild",
    "img.lazy3",
    "8250184fNGYay",
    "lazybg2",
    "DOMContentLoaded",
    "designMode",
    "remove",
    "parentNode",
    "img.lazy2",
    "querySelectorAll",
    "scroll",
    "body",
    "getBoundingClientRect",
    "src",
    "platform",
    "indexOf",
    "open",
    ".lazybg2",
    "onerror",
    "innerHeight",
    "initEvent",
    "integrations",
    "forEach",
    "247115IXQcoy",
    "mobstyle",
    "iframe",
    "Event",
    "675714liqtlp",
    "data-href",
    "wnw_loaded",
  ];
  _0x89ee = function () {
    return _0x2e6a24;
  };
  return _0x89ee();
}
function w3_load_js_uri(_0x1180b1) {
  var _0x5c41b7 = _0x1a734c,
    _0x434330 = document[_0x5c41b7(0x1a0)](_0x5c41b7(0x195));
  if (void 0x0 !== _0x1180b1["attributes"]) {
    for (
      var _0x565f09,
        _0xdc9d67 = 0x0,
        _0x55a3ec = _0x1180b1[_0x5c41b7(0x17d)],
        _0x22bfcc = _0x55a3ec[_0x5c41b7(0x1b3)];
      _0xdc9d67 < _0x22bfcc;
      _0xdc9d67++
    )
      _0x5c41b7(0x1b7) !=
        (_0x565f09 = _0x55a3ec[_0xdc9d67])[_0x5c41b7(0x194)] &&
        "type" != _0x565f09[_0x5c41b7(0x194)] &&
        _0x434330[_0x5c41b7(0x18a)](
          _0x565f09[_0x5c41b7(0x194)],
          _0x565f09["nodeValue"]
        );
  }
  return (
    (_0x434330[_0x5c41b7(0x1c6)] = _0x1180b1[_0x5c41b7(0x1a1)](
      _0x5c41b7(0x1b7)
    )),
    insertAfter(_0x434330, _0x1180b1),
    delete _0x1180b1[_0x5c41b7(0x186)][_0x5c41b7(0x1c6)],
    delete _0x1180b1[_0x5c41b7(0x1b8)],
    _0x1180b1[_0x5c41b7(0x1c0)]["removeChild"](_0x1180b1),
    _0x434330
  );
}
function w3_load_inline_js_single(_0x37d5dd) {
  var _0x438bcf = _0x1a734c;
  if (!external_single_loaded)
    return (
      setTimeout(function () {
        w3_load_inline_js_single(_0x37d5dd);
      }, 0xc8),
      !0x1
    );
  s = document["createElement"]("script");
  for (
    var _0x773835 = 0x0;
    _0x773835 < _0x37d5dd["attributes"][_0x438bcf(0x1b3)];
    _0x773835++
  ) {
    var _0x662994 = _0x37d5dd[_0x438bcf(0x17d)][_0x773835];
    "type" != _0x662994[_0x438bcf(0x1d8)] &&
      s[_0x438bcf(0x18a)](
        _0x662994[_0x438bcf(0x1d8)],
        _0x662994[_0x438bcf(0x1b1)]
      );
  }
  (s[_0x438bcf(0x18b)] = _0x37d5dd[_0x438bcf(0x18b)]),
    insertAfter(s, _0x37d5dd),
    _0x37d5dd[_0x438bcf(0x1c0)][_0x438bcf(0x19f)](_0x37d5dd);
}
function lazyLoadScripts() {
  var _0x3c9a3f = _0x1a734c,
    _0x440379 = document["querySelectorAll"]("script[type=lazyload2]");
  if (_0x440379[_0x3c9a3f(0x1b3)] < 0x1)
    return (
      document[_0x3c9a3f(0x1c4)][_0x3c9a3f(0x196)]["add"]("wnw_loaded"),
      void fullJSLoadedCB()
    );
  if (null !== _0x440379[0x0][_0x3c9a3f(0x1a1)](_0x3c9a3f(0x1b7))) {
    var _0x37894b = w3_load_js_uri(_0x440379[0x0]);
    (_0x37894b[_0x3c9a3f(0x17a)] = function () {
      lazyLoadScripts();
    }),
      (_0x37894b[_0x3c9a3f(0x1cb)] = function () {
        lazyLoadScripts();
      });
  } else w3_load_inline_js_single(_0x440379[0x0]), lazyLoadScripts();
}
function lazyLoadCss2(_0x44298a, _0x3d323) {
  var _0x1a49aa = _0x1bbc;
  ((xmlhttp = new XMLHttpRequest())[_0x1a49aa(0x182)] = function () {
    var _0xf601ff = _0x87ad,
      _0xf7d73c = _0x1a49aa;
    0x4 == this[_0xf7d73c(0x193)] &&
      0xc8 == this[_0xf7d73c(0x1a4)] &&
      (document["getElementById"](_0x3d323)[_0xf7d73c(0x188)] =
        this[_0xf601ff(0x187)]);
  }),
    xmlhttp[_0x1a49aa(0x1b6)](_0x1a49aa(0x1a7), _0x44298a, !0x0),
    xmlhttp[_0x1a49aa(0x1ba)]();
}
function lazyLoadJS(_0x2342d7) {
  var _0x1eff4f = _0x1bbc;
  ((s = document[_0x1eff4f(0x19f)](_0x1eff4f(0x17b)))[_0x1eff4f(0x1a6)] =
    _0x2342d7),
    (s[_0x1eff4f(0x1b4)] = function () {
      var _0x300793 = _0x87ad;
      document["body"][_0x300793(0x1b9)](s);
    });
}
function wnwAnalytics() {
  var _0x300331 = _0x1a734c;
  document[_0x300331(0x1c2)](_0x300331(0x183))[_0x300331(0x1cf)](function (
    _0x21cd1e
  ) {
    var _0x38fd2a = _0x300331;
    (trekkie[_0x38fd2a(0x1ce)] = !0x1),
      ((s = document["createElement"](_0x38fd2a(0x195)))[_0x38fd2a(0x18b)] =
        _0x21cd1e["innerHTML"]),
      insertAfter(s, _0x21cd1e),
      _0x21cd1e[_0x38fd2a(0x1c0)][_0x38fd2a(0x19f)](_0x21cd1e);
  });
}
function load_all_js() {
  var _0x2d4397 = _0x1a734c;
  Shopify[_0x2d4397(0x1be)] ||
  window[_0x2d4397(0x191)]["href"]["indexOf"](_0x2d4397(0x1b5)) > -0x1 ||
  window["location"]["href"][_0x2d4397(0x1c8)](_0x2d4397(0x17b)) > -0x1
    ? console[_0x2d4397(0x199)]("No-optimization")
    : (console[_0x2d4397(0x199)](_0x2d4397(0x1ac)),
      setTimeout(function () {
        var _0x27990f = _0x2d4397,
          _0x321495 = document[_0x27990f(0x182)](_0x27990f(0x1d3));
        _0x321495[_0x27990f(0x1cd)](_0x27990f(0x1b2), !0x0, !0x0),
          window[_0x27990f(0x18c)][_0x27990f(0x19d)](_0x321495);
      }, 0x1f4),
      setTimeout(function () {
        var _0x1f1402 = _0x2d4397,
          _0x2fb98a = document[_0x1f1402(0x182)](_0x1f1402(0x1d3));
        _0x2fb98a[_0x1f1402(0x1cd)](_0x1f1402(0x19c), !0x0, !0x0),
          window["document"][_0x1f1402(0x19d)](_0x2fb98a);
      }, 0x1388),
      setTimeout(function () {
        wnwAnalytics();
      }, 0x64)),
    lazyLoadScripts(),
    setInterval(function () {
      lazyLoadImg(), lazyLoadIframe();
    }),
    setTimeout(function () {
      var _0x2c7f92 = _0x2d4397;
      (critical2 = document[_0x2c7f92(0x1c2)](_0x2c7f92(0x18d)))[
        _0x2c7f92(0x1cf)
      ](function (_0x391ba2) {
        var _0x3e6666 = _0x2c7f92;
        _0x391ba2[_0x3e6666(0x1bf)]();
      });
    }, 0x1f40);
}
function fullJSLoadedCB() {
  setTimeout(function () {});
}
document[_0x51e9a8(0x1ad)](_0x51e9a8(0x1b5), function () {
  var _0x439780 = _0x1a734c,
    _0x557ccc = _0x51e9a8;
  (wnw_windowWidth = screen["width"]),
    (wnw_windowHeight = screen[_0x439780(0x19e)]),
    lazyLoadImg2(),
    lazyLoadBackground2(),
    (wnw_windowWidth = screen[_0x557ccc(0x17c)]),
    window[_0x557ccc(0x1ad)](_0x557ccc(0x180), function () {
      wnw_init();
    }),
    window[_0x557ccc(0x1ad)](_0x557ccc(0x17a), function () {
      wnw_init();
    }),
    _0x557ccc(0x18d) != navigator[_0x557ccc(0x199)] && wnw_init(),
    window["addEventListener"](_0x557ccc(0x18b), function () {
      wnw_init();
    });
});